<template>
    <div>
        <!--    <div class="imgHeader">-->
        <!--      <img src="/img/9产品展示-banner.jpg" alt="" />-->
        <!--    </div>-->
        <div class="w main">
            <h3 class="title" style="text-align:center">{{ $t('productDisplay.title') }}</h3>
            <div class="line line1"></div>
            <p style="margin-top: 15px;text-align: left;line-height: 1.5;font-weight: bold;">
                <span style="font-size: 18px;">{{ $t('productDisplay.desc1') }}</span> <br><br>
                {{ $t('productDisplay.desc2') }} <br>
                {{ $t('productDisplay.desc3') }} <br>
                {{ $t('productDisplay.desc4') }}
            </p>
            <div class="container flex">
                <div
                        class="product-card"
                        v-for="(item,index) in list"
                        :key="item.title"
                        @click="toDetails(index)"
                        data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="1000"
                >
                    <img :src="item.imgUrl" alt="" />
                    <div class="productTitle">{{ $t(`${item.title}`) }}</div>
                </div>
            </div>
        </div>
        <dialog_product_detail :dialogVisible.sync="dialogVisible" :info="info" />
    </div>
</template>

<script>
import dialog_product_detail from '@/components/dialog_product_detail.vue'
import { classifyList } from '@/constants/classify'
import { t } from '@/VueI18n'

export default {
    name: 'ProductDisplay',
    components: { dialog_product_detail },
    data() {
        return {
            list: classifyList,
            dialogVisible: false,
            info: {},
        }
    },
    methods: {
        toDetails(index) {
            this.$router.push(`/Classify/${index}`)
        },
    },
}
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 50px;
}
.container {
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  font-size: 0px;
}
.product-card {
  margin-bottom: 40px;
  cursor: pointer;
  img {
    width: 336px;
    height: 336px;
  }
  &:hover {
    transition: all 0.5s;
    transform: scale(1.1);
    box-shadow: 0 0 10px var(--box-shadow);
    .productTitle {
      background-color: var(--font-color);
      color: #fff;
    }
  }
}
.productTitle {
  height: 45px;
  line-height: 45px;
  border: 1px solid var(--bg-color);
  text-align: center;
  font-size: 18px;
}
.el-dialog {
  border-radius: 30px;
}
</style>